// --- Dependencies -------------------------------------------------------------------------------
import type { ReactNode } from "react";
// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    /** The message from the last refused write, shown where the admin is already looking. */
    writeError?: string | null;
    children: ReactNode;
};

// --- Logic --------------------------------------------------------------------------------------

/**
 * The shell all six list screens sit in: page padding, the gaps between the four sections, and the
 * classes their filters and row controls share.
 *
 * It exists because those screens are the same screen six times. Left to themselves each one grew its
 * own near-identical stylesheet, and the first change to a filter dropdown would have had to be made
 * six times and would have been made in four.
 */
export default function ListScreen({ writeError, children }: Props) {
    return (
        <div className="list-screen">
            {writeError && <p className="list-screen-error">{writeError}</p>}
            {children}
        </div>
    );
}
